

























































import {gmapApi} from "vue2-google-maps";
import CommonBase from "../CommonBase";
import {Component, Prop, Watch} from "vue-property-decorator";
import {initVueGoogleMaps} from "../../modules/maps";
import {
  AddressSearchResultItem,
  GeoCircle,
  GeoPolygon,
  JLocation, SearchedMarker,
  TerminalLocation,
  TerminalLocationArea,
  TerminalLocationGeofence
} from "../../modules/models";
import {Area, Circle, Drawingmethod, MaxSquareMetersAllowed, Polygon} from "../../modules/mapmodels";
import {ErrorColor, GoogleMapsInitLocation, MaxLocationAreaCountPerLocation,} from "../../modules/constants";
import {MapDrawingController} from "../../modules/mapDrawingController";

initVueGoogleMaps();

    @Component
    export default class Areamap extends CommonBase {
        @Prop()
        terminalLocation!: TerminalLocation;

        @Prop({default: () => []})
        terminalPoints!: JLocation[];

        @Prop({default: false})
        editable!: boolean;

        @Prop({default: Drawingmethod.POLYGON})
        drawingmethod!: Drawingmethod | null;

        @Prop({default: () => []})
        value!: TerminalLocationArea[];

        @Prop({default: '300px'})
        height!: string;

        @Prop({default: () => []})
        fences!: TerminalLocationGeofence[];

        @Prop({default: false})
        readonly!: boolean;

        @Prop({ default: null })
        focusedArea: Area | null = null;

        @Prop({ default: null })
        initialAddressInput?: string | null;

        addressesLoading: boolean = false;
        addressInput: string | null = null;
        addressInputUsed: boolean = false;
        addressSearchError: string[] = [];
        availableAddresses: AddressSearchResultItem[] = [];

        pAreas: Area[] = [];

        searchedMarker: SearchedMarker | null = null;

        get areas(): Area[] {
            return this.pAreas;
        }
        set areas(v: Area[]) {
            this.pAreas = v;
            this.$emit("update:map-areas", v);
        }


        @Watch("value", {immediate: true})
        async makeAreas() {
            await this.googleWaiter();
            const map = await this.mapPromise();
            this.reset(); // Remove existing loaded areas before loading the new
            for (let tArea of this.value) {
                let area: Area | null = null;
                if (tArea.geo instanceof GeoCircle) {
                    // Draw circle on map
                    const mapCircle = new window.google.maps.Circle({
                        center: tArea.geo.center.asLatLng(),
                        radius: tArea.geo.radius,
                        map: map,
                    });
                    area = new Circle(mapCircle);

                } else if (tArea.geo instanceof GeoPolygon) {
                    // Draw polygon on map
                    const mapPoly = new window.google.maps.Polygon({
                        paths: tArea.geo.points.map((p) => p.asLatLng()),
                        map: map,
                    });
                    // Create Polygon instance
                    area = new Polygon(mapPoly);
                }
                if (area != null) {
                    area.id = tArea.id;
                    const idx = this.areas.length + 1;
                    area.label = "" + idx;
                    this.areas = this.areas.concat(area);
                }
            }
            if(this.mapCenter == GoogleMapsInitLocation) {
                this.mapCenter = this.initialMapCenter();
            }
        }

        @Watch("drawingmethod")
        onDrawingmethodChanged(){
            if(this.drawingController != null) {
                this.drawingController.setDrawingmethod(this.drawingmethod);
            }
        }

        clearAddressSearch() {
          this.addressInput = "";
          this.addressesLoading = false;
          this.addressSearchError = [];
          this.searchedMarker = null;
          this.availableAddresses = [];

          if (this.focusedArea === null) {
            this.mapCenter = this.initialMapCenter();
          }
        }

        addressInputChange(value: string | undefined | null) {
          if (!value) {
            return;
          }

          this.addressInput = value ?? null;
          this.addressInputUsed = true;
        }

        selectAddress(search: any | null | undefined) {
          if (!search) {
            return;
          }

          const lat = search.lat;
          if (typeof lat !== 'number') {
            return;
          }

          const lng = search.lng;
          if (typeof lng !== 'number') {
            return;
          }
          
          this.mapCenter = { lat, lng }
          this.searchedMarker = { lat, lng }
          this.mapZoom = 15;
        }

        @Watch("focusedArea")
        onFocusedAreaChanged() {
          if (this.focusedArea === null) {
            return;
          }

          this.mapZoom = 15;
          this.mapCenter = this.focusedArea.markerPos();
        }

        @Watch("initialAddressInput")
        onInitialAddressInputChanged() {
          if (this.addressInputUsed) {
            return;
          }

          this.searchedMarker = null;
          this.mapCenter = this.initialMapCenter();
          this.addressInput = this.initialAddressInput ?? null;
          this.searchForAddress(true)
        }

        searchForAddress(autoSelect: boolean = false) {
          const geocoder = new window.google.maps.Geocoder();
          if (geocoder === null) {
            this.addressSearchError = ["geocoder unavaliable"]
            return;
          }

          if (!this.addressInput) {
            return;
          }

          this.addressesLoading = true;
          try {
            geocoder.geocode({ address: this.addressInput }, (results, status) => {
              if (status.toString() === "ZERO_RESULTS") {
                this.addressSearchError = [];
                this.availableAddresses = [];
                return;
              }

              if (status.toString() !== "OK") {
                this.addressSearchError = [status.toString()];
                return;
              }

              this.addressSearchError = [];

              if (Array.isArray(results)) {
                this.availableAddresses = results.map(r => ({ address: r.formatted_address, lat: r.geometry.location.lat(), lng: r.geometry.location.lng() }));

                if (results.length === 1) {
                  this.addressInput = results[0].formatted_address;

                  if (autoSelect) {
                    this.selectAddress(this.availableAddresses[0])
                  }
                }
              }
            })
          } finally {
            this.addressesLoading = false;
          }
        }

        removeArea(removeIdx) {
            this.infoAreaIdx = -1; // Hide popup
            const toRemove = this.areas[removeIdx];
            toRemove.mapRemove();
            const areas = this.areas.filter((v, idx) => idx != removeIdx);
            // Fix the label of all areas with index >= removeIdx
            for(let i = removeIdx; i < areas.length; i++) {
                areas[i].label = "" + (i + 1);
            }
            this.areas = areas;
            this.emitValues();
            this.$emit("deleted-area", removeIdx);
        }

        addArea(area: Area) {
            if(area.squareMeters() === 0) {
                const toFewPoints = area instanceof Polygon && area.geoPolygon.points.length < 3;
                const msg = toFewPoints ? `Område må ha markeres med minst tre linjer. Prøv igjen` : `Tomt område, prøv igjen`;
                area.mapRemove();
                this.emitSnack(msg, "warning");
            } else {
                const idx = this.areas.length;
                area.label = "" + idx;
                this.areas = this.areas.concat(area);
                this.emitValues();
                this.$emit("added-area", idx);
            }
        }

        emitValues() {
            this.$emit("input", this.areas.map((a) => a.toTerminalLocationArea(this.terminalLocation.id))) // Reflect the new value externally
        }

        // If an infowindow is to present an area, it's index in pAreas is set here.
        infoAreaIdx  = -1;

        get infoArea(): Area | null {
            if(this.infoAreaIdx > -1) {
                return this.areas[this.infoAreaIdx] || null;
            }
            return null;
        }

        mapClicked() {
            // Hide any active info window when user clicks on the map outside of it.
            if(this.infoAreaIdx > -1) {
                this.infoAreaIdx = -1;
            }
        }

        map: google.maps.Map | null = null; // Reference to the map object

        mapCenter: google.maps.LatLngLiteral | google.maps.LatLng = GoogleMapsInitLocation;

        initialMapCenter(): google.maps.LatLngLiteral | google.maps.LatLng {
            // Improve this by creating a boundingbox with all terminalpoints and areacenters, set the map boundingbox matching terminalpoints.
            if(this.value.length > 0) { // Return first area center location for now
                this.mapZoom = 15;
                return this.areas[0].markerPos();
            } else if(this.terminalPoints.length > 0) { // Return first terminal location for now
                this.mapZoom = 15;
                return this.terminalPoints[0].asLatLng();
            }
            // Return default if no terminal location found
            // When showing default location, zoom out
            this.mapZoom = 6;
            return GoogleMapsInitLocation;
        }

        // Map should be zoomed in quite close when there is a terminal location to center on. Should have a wide initial zoom when we return the default location
        mapZoom = 6;


        get areaIcon() {
            /* eslint-disable */
            return {
                path: google.maps.SymbolPath.CIRCLE,
                fillColor: "#1d7c14",
                fillOpacity: 0.6,
                scale: 12,
                strokeWeight: 0,
            };
            /* eslint-enable */
        }

        get googReady() {
            return gmapApi();
        }
        @Watch("googReady")
        onGoogReady() {
            this.$emit("googReady", !!this.googReady);
        }
        googleWaiter() {
            if(this.googReady) {
                return Promise.resolve(true);
            }
            return new Promise((resolve) => {
                this.$once("googReady", (r) => resolve(!!r));
            });
        }

        get isEditing() {
            return this.drawingController != null && this.drawingController.isEnabled;
        }

        drawingController: MapDrawingController | null = null;
        drawingEnableToken = 0;

        @Watch("editable", {immediate: true})
        onEditableChanged() {
            if(this.editable) {
                this.enableDrawing();
            } else {
                this.disableDrawing();
            }
        }

        async enableDrawing() {
            const token = ++this.drawingEnableToken;
            await this.googleWaiter();
            this.map = this.map || await this.mapPromise();
            if(!this.editable || token !== this.drawingEnableToken) {
                return;
            }
            if(this.drawingController == null) {
                this.drawingController = new MapDrawingController(this.map, {
                    onAreaComplete: (area: Area) => this.addCompletedArea(area),
                });
            }
            this.drawingController.setDrawingmethod(this.drawingmethod);
            this.drawingController.enable();
        }

        addCompletedArea(area: Area) {
            if(this.areas.length >= MaxLocationAreaCountPerLocation) {
                this.emitSnack(`Anleggsområde IKKE lagt til. Maks ${MaxLocationAreaCountPerLocation } områder tillatt`, ErrorColor);
                area.mapRemove();
            } else if(area.squareMeters() > MaxSquareMetersAllowed) {
                this.emitSnack("Anleggsområde IKKE lagt til. Markert område for stort.", ErrorColor);
                area.mapRemove();
            } else {
                this.addArea(area);
            }
        }

        disableDrawing() {
            this.drawingEnableToken++;
            if(this.drawingController != null) {
                this.drawingController.destroy();
            }
            this.drawingController = null;
        }

        // Resets loaded state to zero
        reset() {
            for(let a of this.areas) {
                a.mapRemove();
            }
            this.areas = [];
        }

        async mapPromise(): Promise<google.maps.Map> {
            return (this.$refs.mapRef as any).$mapPromise;
        }

        mounted() {
            const gw = this.googleWaiter();
            const mp = this.mapPromise();
            gw.then(() => {
                mp.then((map) => {
                    this.map = map;
                    this.$emit("at-areamap-mounted", true);
                });
            });
        }

        beforeDestroy() {
            this.disableDrawing();
        }
    }
